import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("landing-page-footer", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-footer"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
    view: {
      onRender({ model }) {
        model.find(".scrile-link").forEach(i =>
          i.set({
            locked: true,
            editable: false,
            selectable: false,
            hoverable: false,
          })
        );
      },
    },
  });

  BlockManager.add("landing-page-footer", {
    ...config,
    label: "Footer",
    content: template,
  });
}
